// extracted by mini-css-extract-plugin
export var label = "_b3-5";
export var slideContainer = "_b3-0";
export var slider = "_b3-1";
export var sliderLg = "_b3-4";
export var sliderMd = "_b3-3";
export var sliderSm = "_b3-2";